import { render, staticRenderFns } from "./stayReceiv.vue?vue&type=template&id=9db3178e&scoped=true&"
import script from "./stayReceiv.vue?vue&type=script&lang=js&"
export * from "./stayReceiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db3178e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9db3178e')) {
      api.createRecord('9db3178e', component.options)
    } else {
      api.reload('9db3178e', component.options)
    }
    module.hot.accept("./stayReceiv.vue?vue&type=template&id=9db3178e&scoped=true&", function () {
      api.rerender('9db3178e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/afterSale/comp/stayReceiv.vue"
export default component.exports